import * as React from 'react';

function DigitalReceipt(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={77.776}
      height={51.851}
      viewBox='0 0 77.776 51.851'
      {...props}
    >
      <path
        id='Path_18'
        data-name='Path 18'
        d='M7.812,7A5.809,5.809,0,0,0,2,12.812V53.039a5.809,5.809,0,0,0,5.812,5.812H73.964a5.809,5.809,0,0,0,5.812-5.812V12.812A5.809,5.809,0,0,0,73.964,7Zm-.051,5.761H74.015V53.089H7.761Zm5.761,5.761v5.761H42.328V18.522Zm0,11.522v5.761h5.761V30.045Zm11.522,0v5.761h5.761V30.045Zm11.522,0v5.761h5.761V30.045ZM13.522,41.567v5.761H42.328V41.567Zm34.567,0v5.761H68.254V41.567Z'
        transform='translate(-2 -7)'
        fill='#fff'
      />
    </svg>
  );
}
export default DigitalReceipt;
